import { render, staticRenderFns } from "./consultaList.vue?vue&type=template&id=cf4e8c36&"
import script from "./consultaList.js?vue&type=script&lang=js&"
export * from "./consultaList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports